<template>
  <div
    :id="`${title}_card_title`"
    class="rs-sidebar-card-list"
    :class="{ active: active }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div class="rs-sidebar-card-list__info">
      <div
        :class="`rs-sidebar-card-list__header truncate ${date || publishDate || url ? 'multiline' : ''}`"
      >
        <div class="row">
          <RsPropertyTitle
            class="col-9"
            :text="title"
          />
          <span
            v-if="date"
            class="col-3 date"
          > {{ date }} </span>
        </div>
        <RsPropertyType
          v-if="publishDate"
          :text="'Publish Date: ' + publishDate"
        />
        <RsPropertyType
          v-if="url"
          :text="url"
        />
      </div>
      <ul
        v-show="hover && isDeletePermitted"
        class="action-toolbar"
      >
        <li
          title="Delete"
          @click="$emit('on-remove')"
        >
          <i class="far fa-trash" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsSidebarCardList',

  props: {
    title: String,
    publishDate: String,
    url: String,
    subtitle: String,
    active: {
      type: Boolean,
      default: false,
    },
    date: String,
  },
  data() {
    return {
      hover: false,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.rs-sidebar-card-list {
  position: relative;
  border-bottom: 1px solid $extra-light-gray;
  cursor: pointer;
  .publish-text{
    margin: 0;
    font-size: .75rem;
    font-weight: 600;
    color: $dark-gray;
  }
  &__header {
    position: relative;
    padding: 1rem;
    width: 100%;

    &.multiline {
      padding: 0.75rem 1rem;
    }
  }
  &__info{
    display: flex;
  }
  &.active{
    border-left: 0.25rem solid $secondary-color;
    background-color: rgba(0,0,0,0.04);
  }
  &--unsaved{
    background-color: rgba($error, 0.1);
    border-color: #FBCFD5;
    &:before{
      position: absolute;
      content: '';
      height: 1px;
      width: 100%;
      top: -1px;
      background-color: #FBCFD5;
    }
    .rs-sidebar-card-list__header{
      h4,span{
        color: $error;
      }
    }
  }
  .rs-prop-title {
    font-size: 1rem;
    line-height: 1rem;
    margin-bottom: 0;
    cursor: pointer;
  }
  .date {
    font-size: 0.8rem;
    color: $dark-gray;
  }
  .rs-prop-type {
    color: $dark-gray;
  }

  .rs-prop-icon {
    margin-right: 0;
    .fa-eye-slash {
      color: $error;
    }
  }
  &:hover{
    .rs-prop-title{
      color: $secondary-color;
    }
  }
}
.action-toolbar{
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  background-color: $gray-200;
  cursor: default;
  li{
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    opacity: 0.5;
    margin: 0 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    list-style: none;
    .rs-icon{
      color: $tertiary-dark;
      // opacity: 0.8;
    }
    &:before{
      content: '';
      position: absolute;
      display: block;
      bottom: -10px;
      left: -10px;
      right: -10px;
      top: -10px;
      z-index: -1;
      opacity: 0;
      border-radius: 50%;
      background: none;
      box-sizing: border-box;
      transform: scale(0);
      transition-property: transform,opacity;
      transition-duration: .15s;
      transition-timing-function: cubic-bezier(0.4,0.0,0.2,1);
    }
    &:hover{
      .rs-icon{
        opacity: 1;
      }
      &:before{
        opacity: 1;
        transform: scale(1);
        background-color: rgba($secondary-color, .2);
      }
    }
  }
}
</style>
